import {selectEcommerceDisplayPrice} from '~/common/fabric/reducers/review/selectors';
import {
  GREETING_CARD_CHECKED_OUT,
  GREETING_CARD_E_GIFT_CHECKED_OUT,
} from '~/common/fabric/reducers/review/constants';
import {pushDataLayerEcommerceObject} from '~/CreateFabricGreetingCard/utils/dataTracking';

export const dataLayerMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case GREETING_CARD_CHECKED_OUT: {
      next(action);

      const state = store.getState();
      const eviteEvent = state?.eviteEvent;
      const calc = state?.review?.calc;
      const purchase_response = state?.review?.purchase_response;

      const purchasePrice = selectEcommerceDisplayPrice(state);

      const ga4Data = {
        event: 'purchase',
        ecommerce: {
          transaction_id: purchase_response?.transaction,
          value: calc.centsToBeCharged / 100,
          tax: 0.0,
          shipping: 0.0,
          currency: 'USD',
          items: [
            {
              item_name: eviteEvent.title,
              item_id: eviteEvent.template_name,
              item_brand: 'Evite',
              item_category: eviteEvent.event_type,
              item_list_name: 'Fabric Greeting Card',
              price: purchasePrice,
              quantity: calc.numGuestsBeingAdded,
              coupon: calc.promocode,
              discount: calc.promoDiscountStr.substring(1),
            },
          ],
        },
      };

      pushDataLayerEcommerceObject(ga4Data);
      break;
    }

    case GREETING_CARD_E_GIFT_CHECKED_OUT: {
      next(action);

      const state = store.getState();
      const eviteEvent = state?.eviteEvent;
      const calc = state?.review?.calc;
      const purchaseResponse = state?.review?.e_gift_purchase_response;

      const ga4Data = {
        event: 'purchase',
        ecommerce: {
          transaction_id: purchaseResponse.id,
          value: calc.centsToBeCharged / 100,
          tax: 0.0,
          shipping: 0.0,
          currency: 'USD',
          items: [
            {
              item_name: eviteEvent.title,
              item_id: eviteEvent.template_name,
              item_brand: 'Evite',
              item_category: eviteEvent.event_type,
              item_list_name: 'Fabric Greeting Card',
              price: 0.0,
              quantity: calc.numGuestsBeingAdded,
              coupon: '',
              discount: 0.0,
            },
            {
              item_name: eviteEvent.gift_card_data.product_config_name,
              item_id: eviteEvent.gift_card_data.product_config_id,
              item_brand: eviteEvent.gift_card_data.product_config_name,
              item_category: '',
              item_list_name: 'GIFT_CARD',
              price: eviteEvent.gift_card_data.amount_in_cents / 100,
              quantity: calc.numGuestsBeingAdded,
            },
          ],
        },
      };

      pushDataLayerEcommerceObject(ga4Data);
      break;
    }
    default:
      next(action);
      break;
  }
};
